export const MAX_CHAR = 250;

export const format = (text: string, trim: boolean) => {
  if (trim) {
    return `${text.substr(0, MAX_CHAR)}${text.length > MAX_CHAR ? "..." : ""}`;
  }
  return text;
};
